import { Routes, Route } from "react-router-dom";
import { Books } from "./pages/Books";
import { Explore } from "./pages/Explore";
import { Home } from "./pages/Home";
import { Moments } from "./pages/Moments";
import { Read } from "./pages/Read";
import { ResetPassword } from "./pages/ResetPassword";

export default function App() {
  return (
    <Routes>
      <Route path="/books" element={<Books />} />
      <Route path="/books/:sourceId" element={<Books />} />
      <Route path="/read" element={<Read />} />
      <Route path="/read/:sourceId" element={<Read />} />
      <Route path="/explore" element={<Explore />} />
      <Route path="/p/:id" element={<Explore />} />
      <Route path="/moments" element={<Moments />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}
